import React, {FC, useCallback} from 'react';
import {Order, StudentOrderBy} from '../../interfaces';
import {Box, TableCell, TableSortLabel} from "@mui/material";
import {visuallyHidden} from "@mui/utils";
import {useTranslation} from "../../services";

interface ManageStudentsTableHeadInterface {
	title: string;
	order: Order;
	columnName: StudentOrderBy;
	orderBy: StudentOrderBy | undefined;
	onRequestSort: (
		event: React.MouseEvent<unknown>,
		property: StudentOrderBy
	) => void;
}

const ManageStudentsTableHead: FC<ManageStudentsTableHeadInterface> = ({
	columnName,
	onRequestSort,
	orderBy,
	order,
	title,
}) => {
    const { t } = useTranslation();
    const createSortHandler = useCallback(
        (property: StudentOrderBy) => (event: React.MouseEvent<unknown>) => {
            onRequestSort(event, property);
        },
        [onRequestSort]
    );

	return (
        <TableCell sortDirection={orderBy === columnName ? (order as any) : false}>
            <TableSortLabel
                active={orderBy === columnName}
                direction={orderBy === columnName ? (order as any) : Order.ASC}
                onClick={createSortHandler(columnName as StudentOrderBy)}
            >
                {t(title)}
                {orderBy === columnName ? (
                    <Box component="span" sx={visuallyHidden}>
                        {order === Order.DESC ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                ) : null}
            </TableSortLabel>
        </TableCell>
    );
};

export default ManageStudentsTableHead;
